// 9fbef606107a605d69c0edbcd8029e5d
export const PICKUP_FORM_NAME = 'PickupForm';

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_PICKUP_DETAILS = {
  firstName: '',
  lastName: '',
  alternateFirstName: '',
  alternateLastName: '',
  alternateEmailAddress: '',
};
